import { PaginationLinks } from './pagination-links.interface';
import { PaginationMeta } from './pagination-meta.interface';

export class Pagination<Item, Metadata = any> {
  items: Item[];
  links: PaginationLinks;
  meta: PaginationMeta<Metadata>;

  constructor(items: Item[], meta?: PaginationMeta<Metadata>, links?: PaginationLinks) {
    this.items = items;
    this.meta = this.setMeta(meta);
    this.links = links || {};
  }

  private setMeta(meta?: PaginationMeta<Metadata>): PaginationMeta<Metadata> {
    return meta || {
      totalItems: 0,
      itemCount: 0,
      itemsPerPage: 0,
      totalPages: 0,
      currentPage: 1,
    };
  }
}
